/**
 * Testimonial carousel
 * - Cycles through testimonials automatically
 * - Allows manual navigation
 */

export function initTestimonialCarousel(carousel) {
  const slides = carousel.querySelectorAll('.testimonial-slide');
  const dots = carousel.querySelectorAll('.carousel-dot');
  const prevBtn = carousel.querySelector('.carousel-prev');
  const nextBtn = carousel.querySelector('.carousel-next');
  
  if (!slides.length) return;
  
  let currentSlide = 0;
  let interval;
  const intervalTime = 5000; // 5 seconds per slide
  
  // Function to show a specific slide
  const showSlide = (index) => {
    // Hide all slides
    slides.forEach(slide => {
      slide.classList.add('hidden');
      slide.classList.remove('animate-fade-in');
    });
    
    // Remove active class from all dots
    dots.forEach(dot => {
      dot.classList.remove('bg-accent1');
      dot.classList.add('bg-gray-300');
    });
    
    // Show the current slide with animation
    slides[index].classList.remove('hidden');
    slides[index].classList.add('animate-fade-in');
    
    // Add active class to current dot
    dots[index].classList.remove('bg-gray-300');
    dots[index].classList.add('bg-accent1');
    
    // Update current slide
    currentSlide = index;
  };
  
  // Function to go to the next slide
  const nextSlide = () => {
    let next = currentSlide + 1;
    if (next >= slides.length) {
      next = 0;
    }
    showSlide(next);
  };
  
  // Function to go to the previous slide
  const prevSlide = () => {
    let prev = currentSlide - 1;
    if (prev < 0) {
      prev = slides.length - 1;
    }
    showSlide(prev);
  };
  
  // Start auto-sliding
  const startAutoSlide = () => {
    interval = setInterval(nextSlide, intervalTime);
  };
  
  // Stop auto-sliding
  const stopAutoSlide = () => {
    clearInterval(interval);
  };
  
  // Event listeners for dots
  dots.forEach((dot, index) => {
    dot.addEventListener('click', () => {
      showSlide(index);
      stopAutoSlide();
      startAutoSlide();
    });
  });
  
  // Event listeners for prev/next buttons
  if (prevBtn) {
    prevBtn.addEventListener('click', () => {
      prevSlide();
      stopAutoSlide();
      startAutoSlide();
    });
  }
  
  if (nextBtn) {
    nextBtn.addEventListener('click', () => {
      nextSlide();
      stopAutoSlide();
      startAutoSlide();
    });
  }
  
  // Show the first slide and start auto-sliding
  showSlide(0);
  startAutoSlide();
  
  // Pause auto-sliding when user hovers over carousel
  carousel.addEventListener('mouseenter', stopAutoSlide);
  carousel.addEventListener('mouseleave', startAutoSlide);
}